import { FC, memo } from 'react';
import classNames from 'classnames';

import { BANNER_TYPE, TopBannerState } from 'application/components/widgets/TopBanner/useTopBannerState';

import { Country } from 'domain/api/graphql/generated';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import IconX from '@zvuk-b2b/react-uikit/ui/icons/X';

import { TEXTS } from './texts';
import TrialBanner from './TrialBanner';
import UnpaidBanner from './UnpaidBanner';
import PaymentSchemaBanner from './PaymentSchemaBanner';

import styles from './index.module.scss';

interface TopBannerProps {
  className?: string;
  banner: TopBannerState;
  isBillingPage: boolean;
  onClose: () => void;
  country: Country;
  isSBBOLPayment: boolean;
}

const TopBanner: FC<TopBannerProps> = ({ banner, onClose, className, isBillingPage, country, isSBBOLPayment }) => {
  if (banner.type === BANNER_TYPE.PAYMENT && !isBillingPage) {
    return (
      <PaymentSchemaBanner
        banner={banner}
        className={className}
      />
    );
  }

  if (banner.type === BANNER_TYPE.TRIAL && !isBillingPage) {
    return (
      <TrialBanner
        banner={banner}
        className={className}
        onClose={onClose}
        country={country}
      />
    );
  }

  if (banner.type === BANNER_TYPE.GRACE) {
    return (
      <div
        className={classNames(styles.TopBanner, className)}
        data-type={banner.type}>
        <div className={styles.TopBannerDescription}>
          {isSBBOLPayment ? TEXTS.BANNER_GRACE_SBBOL_TEXT : TEXTS.BANNER_GRACE_TEXT}
        </div>

        <Button
          elementId="button-billing-banner-close"
          className={styles.TopBannerCloseButton}
          onClick={onClose}
          type={ButtonType.PLAIN}>
          <IconX className={styles.TopBannerCloseButtonIcon} />
        </Button>
      </div>
    );
  }

  if (banner.type === BANNER_TYPE.UNPAID && !isBillingPage) {
    return (
      <UnpaidBanner
        banner={banner}
        onClose={onClose}
        className={className}
      />
    );
  }

  return null;
};

export default memo(TopBanner);
